import React from "react";
import { MenuGridShimmer } from "../Shimmer/ShimmerPrimitives";
import "./RestaurantBootstrapLoader.css";

/** Shown below site chrome while restaurant bootstrap is in progress. */
export default function RestaurantBootstrapLoader({ message = "Loading restaurant…" }) {
    return (
        <div className="restaurant-bootstrap-loader" role="status" aria-live="polite">
            <span className="visually-hidden">{message}</span>
            <MenuGridShimmer rows={4} />
        </div>
    );
}
